module.exports = __webpack_public_path__ + "img/Artboard 49.51d53b90.png";